import axios from 'axios';

import { AcceptShowingRequestDto } from '../interfaces/appect-showing-request.interface';
import { DeclineShowingRequestDto } from '../interfaces/decline-showing-request.dto';
import { RescheduleShowingRequestDto } from '../interfaces/reschedule-showing-request.interface';
import { RescheduledShowingDto } from '../interfaces/rescheduled-showing.dto';
import { ShowingRequestDto } from '../interfaces/showing-request.interface';

class ShowingRequestService {
  async accept(propertyId: string, payload: AcceptShowingRequestDto): Promise<ShowingRequestDto> {
    const response = await axios.post(`showing-request/accept/property/${propertyId}`, payload);

    return response.data;
  }

  async decline(propertyId: string, showingRequestId: string, declineReason?: string): Promise<ShowingRequestDto> {
    const body: DeclineShowingRequestDto = { showingRequestId };

    if (declineReason) {
      body.declineReason = declineReason;
    }

    const { data } = await axios.post(`showing-request/decline/property/${propertyId}`, body);

    return data;
  }

  async reschedule(propertyId: string, payload: RescheduleShowingRequestDto): Promise<RescheduledShowingDto> {
    const { data } = await axios.post(`showing-request/reschedule/property/${propertyId}`, { ...payload });

    return data;
  }
}

export default new ShowingRequestService();
